// Each JSON in this directory is a *partial* override of the matching upstream
// `app/javascript/dashboard/i18n/locale/en/<name>.json`. The top-level
// dashboard i18n loader deep-merges this object onto the upstream en bundle,
// so any key not listed here keeps its upstream translation.

import conversation from './conversation.json';
import integrations from './integrations.json';
import settings from './settings.json';

export default {
  ...conversation,
  ...integrations,
  ...settings,
};
